module.exports = __webpack_public_path__ + "91e93ef42edc10c98f67ca5bb520d4a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/bundles/common/components/object_on_map/map_home_spot@2x.png
// module id = 976
// module chunks = 0